import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-7N4EOEYR.mjs";
import "./chunk-K5T4RW27.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
